import React from 'react'
import MaterialSymbol from '../material-symbol'

const RemoveCircleOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="remove_circle_outline" {...props} />
))

RemoveCircleOutline.displayName = 'RemoveCircleOutline'

export default RemoveCircleOutline
